import { render, staticRenderFns } from "./OverviewSearch.vue?vue&type=template&id=19ce3f1c"
import script from "./OverviewSearch.vue?vue&type=script&lang=js"
export * from "./OverviewSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports